// extracted by mini-css-extract-plugin
export default {"web-url-container":"WebUrl_web-url-container__JIiMe","web-url-iframe":"WebUrl_web-url-iframe__J15rk"};